export default {
  sizes: {
    md: {
      field: {
        pl: "3",
        fontSize: "sm",
      },
    },
  },
  variants: {
    semiFlush: {
      field: {
        border: "1px solid",
        borderColor: "gray.200",
        borderRadius: "6px",
        paddingLeft: "10px",
      },
    },
    editable: {
      field: {
        border: "1px solid",
        borderColor: "gray.200",
        paddingLeft: "8px",
      },
    },
    leftIcon: {
      field: {
        border: "1px solid",
        borderColor: "gray.200",
        pl: "10",
      },
    },
  },
};
